$(function() {
     $('.product-filter-section-title').click(function() {
          $(this).next().toggle("fast");
          return false;
      }).next().show();
     $('.product-filter-section li a').click(function() {
          $(this).toggleClass("selected");
      });
  	$('.product-filter-section li').click(function() {
          $(this).toggleClass("selected");
      });
});
